import { useState } from 'react';
import { Link } from 'react-router-dom';
import { faqItems } from '@/mocks/faq';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="py-16 md:py-24 bg-secondary-50">
      <div className="w-full px-4 md:px-6 max-w-3xl mx-auto">
        <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 text-center mb-3">
          Frequently Asked Questions
        </h2>
        <p className="text-sm md:text-base text-foreground-500 text-center mb-10">
          Everything you need to know about OOPBuy Spreadsheet
        </p>

        <div className="space-y-3">
          {faqItems.map((item, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-2xl border border-background-200/60 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-100/50 transition-colors"
              >
                <span className="text-sm md:text-base font-semibold text-foreground-900 pr-4">
                  {item.question}
                </span>
                <div className={`w-8 h-8 flex items-center justify-center rounded-full flex-shrink-0 transition-all ${openIndex === i ? 'bg-accent-400 rotate-45' : 'bg-background-200'}`}>
                  <i className={`text-sm ${openIndex === i ? 'ri-subtract-line text-foreground-950' : 'ri-add-line text-foreground-500'}`}></i>
                </div>
              </button>
              {openIndex === i && (
                <div className="px-5 pb-5">
                  <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                    {item.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-8 text-center">
          <Link
            to="/article/oopbuy-spreadsheet-complete-guide"
            className="inline-flex items-center gap-2 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            Read the complete guide
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}